module.exports = __webpack_public_path__ + "static/media/hot-cat-banner-item-3.2f05507e.png";